export const SAO_PAULO_TZ = 'America/Sao_Paulo';
export const SAO_PAULO_OFFSET = '-03:00';

export function parseBrazilDateTime(value) {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  if (typeof value === 'string') {
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return new Date(`${value}T12:00:00${SAO_PAULO_OFFSET}`);
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?$/.test(value)) return new Date(`${value}${value.length === 16 ? ':00' : ''}${SAO_PAULO_OFFSET}`);
    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}(:\d{2})?$/.test(value)) {
      const normalized = value.replace(' ', 'T');
      return new Date(`${normalized}${normalized.length === 16 ? ':00' : ''}${SAO_PAULO_OFFSET}`);
    }
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatBrazilDateTime(value, fallback = '—') {
  const date = parseBrazilDateTime(value);
  if (!date) return fallback;
  return date.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short', timeZone: SAO_PAULO_TZ });
}

export function formatBrazilDate(value, fallback = '') {
  const date = parseBrazilDateTime(value);
  if (!date) return fallback;
  return date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: SAO_PAULO_TZ });
}

export function formatBrazilTime(value, fallback = '') {
  const date = parseBrazilDateTime(value);
  if (!date) return fallback;
  return date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', timeZone: SAO_PAULO_TZ });
}

export function formatBrazilDateTimeCompact(value, fallback = '') {
  const date = parseBrazilDateTime(value);
  if (!date) return fallback;
  return date.toLocaleString('pt-BR', {
    timeZone: SAO_PAULO_TZ,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).replace(',', '');
}

export function brazilDateParts(value = new Date()) {
  const date = parseBrazilDateTime(value) || new Date();
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: SAO_PAULO_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(date).reduce((acc, part) => ({ ...acc, [part.type]: part.value }), {});
}

export function toBrazilDatetimeLocal(value) {
  const parts = brazilDateParts(value);
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
}

export function fromBrazilDatetimeLocal(value) {
  if (!value) return '';
  return new Date(`${value}:00${SAO_PAULO_OFFSET}`).toISOString();
}

export function todayBrazilDateInput() {
  const parts = brazilDateParts(new Date());
  return `${parts.year}-${parts.month}-${parts.day}`;
}
